import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ShBaseGenericInputFieldComponent } from '../../base-generic-input-field/base-generic-input-field.component';

@Component({
    selector: 'sh-unsupported-input-field',
    templateUrl: './unsupported-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShUnsupportedInputFieldComponent extends ShBaseGenericInputFieldComponent {
    constructor() {
        super();
    }
}
